<template>
    <v-card width="400px">
        <v-app-bar dark :color="primaryColor">
            <div class="d-flex justify-content-between w-100">
                <div class="mt-auto mb-auto cmaj-title">
                  <span v-if="hasField('CONTACT_FIRST_NAME')">{{ contact.first_name }}</span>
                  <span v-if="hasField('CONTACT_LAST_NAME')"> {{ contact.last_name }}</span>
                </div>

                <div class="d-flex"  v-if="!readOnly">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon @click="prepareEdit()">
                                <v-icon dense>edit</v-icon>
                            </v-btn>
                        </template>
                        <div>Modifier</div>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon @click="removeContact()">
                                <v-icon dense>close</v-icon>
                            </v-btn>
                        </template>
                        <div>Supprimer</div>
                    </v-tooltip>
                </div>
            </div>
        </v-app-bar>

        <v-card-text>
            <div v-for="field in fields">
                <card-row :field="field" :contact="contact"></card-row>
            </div>
        </v-card-text>

        <confirm ref="confirm"></confirm>
    </v-card>
</template>

<script>
import CardRow from "./CardRow.vue"
import {mapGetters, mapMutations, mapState} from "vuex"
import Confirm from "../../../../tools/Confirm.vue"

export default {
    name: "ApidaeContactCard",
    components: {Confirm, CardRow},
    props: ['contact', 'fields'],
    methods: {
        ...mapMutations('web_form', ['setAddApidaeContactDialog', 'setCurrentApidaeContact', 'setContactTabDirty',]),
        removeContact() {
            let message = 'Vous allez supprimer le contact'

            message += ' <b>' + this.contact.last_name + ' ' + this.contact.first_name + '</b>'
            message += '. Êtes-vous sûr de vouloir supprimer ce contact ?'

            this.$refs.confirm.open('Attention', message,
                { color: 'red', confirmColor: 'red', cancelColor: '#0b697e' }).
            then((confirm) => {
                if (confirm) {
                    this.provider.contacts = this.provider.contacts.filter(contact => contact.uid !== this.contact.uid)
                    this.setContactTabDirty(true)
                }
            })
        },
        prepareEdit() {
            this.setCurrentApidaeContact(JSON.parse(JSON.stringify(this.contact)))
            this.setAddApidaeContactDialog(true)
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'readOnly']),
        ...mapState('webFormStyle', ['primaryColor']),
      ...mapGetters('web_form', ['hasField']),
    }
}
</script>
